import { render } from "./LockList.vue?vue&type=template&id=ddc6c06a"
import script from "./LockList.vue?vue&type=script&lang=js"
export * from "./LockList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__